import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';

function SrTextList({
  textList,
  ordered,
  fontSize,
  lineHeight,
  font,
  weight,
}) {
  const listProps = {
    className: 'SrTextList',
  };
  const textProps = {
    fontSize,
    lineHeight,
    font,
    weight,
  };

  if (ordered) {
    return (
      <ol {...listProps}>
        {textList.map((text, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index}>
            <SrText {...textProps}>
              <SrFlex>
                <span className='number'>{`${index + 1}. `}</span>
                <span>{text}</span>
              </SrFlex>
            </SrText>
          </li>
        ))}
      </ol>
    );
  }

  return (
    <ul {...listProps}>
      {textList.map((text) => (
        <li key={text}>
          <SrText {...textProps}>{`${text}`}</SrText>
        </li>
      ))}
    </ul>
  );
}

const inlineStyleProp = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

SrTextList.propTypes = {
  textList: PropTypes.array.isRequired,
  ordered: PropTypes.bool,
  fontSize: inlineStyleProp,
  lineHeight: inlineStyleProp,
  font: inlineStyleProp,
  weight: inlineStyleProp,
};

SrTextList.displayName = 'SrTextList';

export default SrTextList;
